import { Route, Switch } from "react-router-dom";
import Error from "./components/documentation/Error";
import Policies from "./components/documentation/Policies";

import Posts from "./components/blog/Posts";
import Post from "./components/blog/Post";
import Project from "./components/projects/Project";

const Routes = () => {
  return (
    <Switch>
      <Route exact path="/life" component={Posts} />
      <Route exact path="/post/:id" component={Post} />
      <Route exact path="/project/:id" component={Project} />
      <Route exact path="/policies" component={Policies} />
      <Route exact path="/error" component={Error} />
    </Switch>
  );
};

export default Routes;
